import {useMemo} from 'react';
import {useIntegrations} from '../../../hooks/api/integrations';
import {useCustomer} from '../../../hooks/api/metadata';
import {IntentGroup} from '../../Intent/IntentModeStore';

export const useIntentGroups = (): IntentGroup[] => {
  const intentSources = useCustomer().intentSources;
  const hasLinkedInIntegration = useIntegrations({}).data?.some(
    ({type}) => type === 'linkedin'
  );

  return useMemo(() => {
    const intentSourceTypes = Array.from(
      new Set(intentSources?.map((source) => source.type) ?? [])
    );

    return [
      ...intentSourceTypes,
      ...(hasLinkedInIntegration ? ['linkedIn' as const] : []),
    ];
  }, [intentSources, hasLinkedInIntegration]);
};
